import { COUNTRY_CODES, COUNTRY_OPTIONS } from '../../constants/countries';

const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

/**
 * Resolves a stored country value (alpha-2 code or legacy free text) to a
 * display name.
 */
export function countryDisplayName(value: string): string {
  if (/^[A-Za-z]{2}$/.test(value)) return displayNames.of(value.toUpperCase()) ?? value;
  return value;
}

const REGIONAL_INDICATOR_OFFSET = 127397;

/**
 * The flag emoji for an alpha-2 code; empty for anything else (legacy free-text
 * rows).
 */
export function countryFlagEmoji(code: string): string {
  const upper = code.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return '';
  const codePoints = [...upper].map((letter) => letter.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET);
  return String.fromCodePoint(...codePoints);
}

/**
 * Resolves a stored country value to its alpha-2 code; null when it cannot, so
 * callers can force a re-pick.
 */
export function countryCodeFromValue(value: string): string | null {
  const trimmed = value.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    const upper = trimmed.toUpperCase();
    return COUNTRY_CODES.includes(upper as (typeof COUNTRY_CODES)[number]) ? upper : null;
  }
  const match = COUNTRY_OPTIONS.find(
    (option) => option.name.toLowerCase() === trimmed.toLowerCase(),
  );
  return match?.code ?? null;
}
